import styled from 'styled-components/macro';
import { CustomScroll } from '@yme/atoms/custom-scroll';
import { colorCoreGray300, colorCoreGray500, colorCoreWhite1000 } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { elevationBottomLvl2 } from '@yme/tokens/elevations';
import { Z_INDEX } from '@yme/tokens/zindex';
import { getTextStyles } from '@yme/utils/styles';
export const FilterListStyled = styled.ul `
  box-sizing: border-box;
  list-style: none;
  margin: 0;
  padding: 0;
  border: none;
  ${({ maxHeight }) => maxHeight && `max-height: ${maxHeight}vh;`}
  ${({ isScrollable }) => isScrollable && 'overflow-y: scroll;'}
  label {
    ${getTextStyles('Ubuntu', 400, 14, 20)}
  }
`;
export const FilterListWrapperStyled = styled.div `
  box-sizing: border-box;
  position: relative;
  padding: 6px;
  width: 100%;
  border-radius: ${CORNER_RADIUS.s};
  box-shadow: ${elevationBottomLvl2};

  background-color: ${colorCoreWhite1000};
  z-index: ${Z_INDEX.level8};
`;
export const ScrollContainerStyled = styled.div `
  ${CustomScroll};
  overflow-y: auto;
  border: none;
`;
export const FilterItemMobileStyled = styled.li `
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
`;
export const FilterItemDesktopStyled = styled.li `
  display: flex;
  justify-content: space-between;
  width: 100%;
  box-sizing: border-box;
  border-radius: ${CORNER_RADIUS.xs};

  padding: ${({ isCheckboxesViewSimple }) => (isCheckboxesViewSimple ? '10px 0' : '8px')};

  @media (hover: hover) {
    &:hover {
      background-color: ${({ isCheckboxesViewSimple }) => isCheckboxesViewSimple ? ' transparent' : colorCoreGray300};
    }
  }
`;
export const SelectAllStyled = styled.div `
  label {
    ${getTextStyles('Ubuntu', 400, 14, 20)}
  }

  padding: 8px 8px 12px 8px;
  border-bottom: 1px solid ${colorCoreGray500};
`;
